import { TranslateService } from '@ngx-translate/core';
import { ChartReadyEvent, ChartType, ChartWrapperComponent, Formatter, ScriptLoaderService } from 'angular-google-charts';
import { Observable, Subscription, map, share } from 'rxjs';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { StateService } from 'src/app/state.service';
import { BasicUsage } from './BasicUsage';

@Component({
  selector: 'app-chart-tab',
  templateUrl: './chart-tab.component.html',
  styleUrls: ['./chart-tab.component.css']
})

export class ChartTabComponent implements OnChanges, OnDestroy, OnInit {

  public isLoading: boolean = false;

  @Input() basicInfo: Array<any>;
  @Input() chartTitle: string = '';
  @Input() stacked : string = 'true';
  @Input() providedColors: string = 'true';
  @Input() currentlyActive: boolean = false;
  @Input() chartId: string;
  @Input() chartType: string;
  private titlePeriod: string;

  toRefreshSubscription: Subscription;
  private currentScreenSizeSubscription: Subscription;

  public width: number = window.innerWidth > 1000 ? Math.round(window.innerWidth * 0.90) : window.innerWidth < 635 ? 600 : (window.innerWidth * 0.98);

  public chartData = [];
  public columns = [];
  public colors = [];
  public options = {
    animation: {
      duration: 250,
      easing: 'ease-in-out',
      startup: true
    },
    colors: ['#1e81b0','#873e23'],
    legend: { position: 'top', alignment: 'center', maxLines: 6 },
    vAxis: {
      format: "#'%'",
      minValue: 0
    },
    isStacked: true,
    innerHeight: 300,
    chartArea: {left: 60, width: '100%'},
  }

  public chartTypeChart = ChartType.ColumnChart;

  public readonly formatters$: Observable<Formatter[]> = this.scriptLoaderService.loadChartPackages().pipe(
    share(),
    map(() => [

    ]
    )
  );

  constructor(
    private translate: TranslateService,
    private scriptLoaderService: ScriptLoaderService,
    private stateService: StateService
  ) {}

  ngOnInit() {

    this.isLoading = true;
    if (this.chartType)
    {
      this.chartTypeChart = this.chartType === "ColumnChart" ? ChartType.ColumnChart : ChartType.LineChart;
    }
    this.currentScreenSizeSubscription =
    this.stateService.currentScreenSize$.subscribe((screenSize) => {
      this.width = screenSize ? Math.round(window.innerWidth * 0.90): window.innerWidth < 635 ? 600 : (window.innerWidth * 0.98);
    } );

  }

  getData() {
    this.translate
    .get([
      'fehmarn_data.period'
    ])
    .subscribe((translations: string) => {
      this.titlePeriod = translations['fehmarn_data.period'];
    });
    if (this.basicInfo.length > 0)
    {
      this.chartData = [];
      this.columns = [];
      this.colors = [];
      this.fillChartData(this.basicInfo);
      this.chartData = Object.assign([], this.chartData);
      this.columns = Object.assign([], this.columns);
      this.options = Object.assign([], this.options);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.currentlyActive)
    {
      setTimeout(() => {
        this.getData();
      });
    }
  }

  fillChartData(basicInfo: BasicUsage[])
  {
    let allcolors = {};

    basicInfo.forEach((element, i) => {
      for (let [key, val] of Object.entries(element.colors)) {
        if (val)
          allcolors[key] = val;
      }
    });

    basicInfo.forEach((element, i) => {
      for (let key in element.colors) {
        if (!this.columns.includes(key))
        {
          this.columns.push(key);
        }
    }});
    this.columns.sort();

    this.columns.forEach((key) => {
      if (allcolors[key])
        this.colors.push(allcolors[key]);
      else this.colors.push("#1e81b0");
    });

    if (this.providedColors === 'true')
    {
        this.options.colors = this.colors;
    }
    else
    {
        this.options.colors = undefined;
    }

    this.options.isStacked = this.stacked === 'true';

    basicInfo.forEach((v, i) =>
    {
      let rowData = [];
      rowData.push(v.month + '/' + v.year);
      this.columns.forEach((type)  => {
          if (v.data[type] !== undefined)
            rowData.push(v.data[type]);
          else rowData.push(0);
      });

      this.chartData.push(rowData);
    });


    this.columns.unshift(this.titlePeriod);
    this.isLoading = false;
  }

  ngOnDestroy(): void {
    if (this.toRefreshSubscription) this.toRefreshSubscription.unsubscribe();
    if (this.currentScreenSizeSubscription)
      this.currentScreenSizeSubscription.unsubscribe();
  }

  onReady(x:ChartReadyEvent)
  {

  }

}

